import { useEffect, useRef, useState } from 'react';
import { t } from './i18n';
import { supabase } from './supabaseClient';
import { clientDinStare, verificatorDinStare } from './conectare';

export default function XCallback() {
  const [status, setStatus] = useState(t('x', 'seConecteaza'));
  // Codul de autorizare e de UNICA FOLOSINTA si la X tine doar 30 DE SECUNDE (documentatia
  // lor): cererea catre `x-oauth` pleaca imediat, fara niciun ecran intre. In dezvoltare,
  // React.StrictMode executa efectele de doua ori, deci fara garda asta se cheama
  // `x-oauth` de doua ori cu acelasi cod: prima cerere il consuma, a doua
  // primeste „does not match authorization code" — sau, si mai rau, cele doua
  // cereri concurente se anuleaza reciproc si NU se salveaza niciun token.
  //
  // Nu e o precautie teoretica: exact asta ne-a costat patru ore pe 10 septembrie
  // 2026, la LinkedIn. Se copiaza dinadins, cu tot cu explicatie.
  //
  // useRef, nu useState: nu trebuie sa provoace o randare, si trebuie citit
  // sincron, inainte ca a doua executie sa apuce sa porneasca cererea.
  const pornit = useRef(false);

  useEffect(() => {
    if (pornit.current) return;
    pornit.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const stareIntoarsa = params.get('state');
    const errorCode = params.get('error');
    const errorMessage = params.get('error_description');

    if (errorCode) {
      console.log('Eroare X:', errorCode, errorMessage);
      setStatus(t('x', 'eroareConectare'));
      setTimeout(() => { window.location.href = `/?error=x_${errorCode}`; }, 1500);
      return;
    }

    if (!code || !stareIntoarsa) {
      window.location.href = '/';
      return;
    }

    // Intoarcerea trebuie sa fie raspunsul la o plecare din browserul acesta (vezi conectare.js).
    const state = clientDinStare(stareIntoarsa);
    if (!state) {
      console.error('Conectare oprita: codul de la intoarcere nu e cel de la plecare.');
      setStatus(t('x', 'eroareConectare'));
      setTimeout(() => { window.location.href = '/?error=x_stare'; }, 1500);
      return;
    }
    // Fara verificatorul PKCE de la plecare, X refuza schimbul; nu mai ardem codul degeaba.
    const verificator = verificatorDinStare();
    if (!verificator) {
      console.error('Conectare X oprita: lipseste verificatorul de la plecare.');
      setStatus(t('x', 'eroareConectare'));
      setTimeout(() => { window.location.href = '/?error=x_stare'; }, 1500);
      return;
    }

    async function proceseazaCallback() {
      try {
        setStatus(t('x', 'seProceseaza'));
        // Acelasi redirect_uri ca la autorizare, altfel X refuza schimbul.
        const redirectUri = window.location.origin + '/auth/x/callback';
        // Sesiunea omului, nu cheia publica: functia verifica cine cheama si daca
        // are drept pe clientul din `state` (SECURITATE_PLAN.md). Ne oprim INAINTE
        // de schimbul codului daca nu exista sesiune, ca sa nu ardem o autorizare.
        const { data: sesiune } = await supabase.auth.getSession();
        const tokenSesiune = sesiune?.session?.access_token;
        if (!tokenSesiune) {
          console.error('Eroare x-oauth: nu exista sesiune');
          setStatus(t('x', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_fara_sesiune`; }, 2000);
          return;
        }
        // Codul si verificatorul merg in CORPUL cererii, nu in adresa: adresele ajung in jurnale.
        const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/x-oauth`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${tokenSesiune}`,
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code, state, redirect_uri: redirectUri, code_verifier: verificator }),
        });
        if (!res.ok) {
          let detaliu = '';
          try { const j = await res.json(); detaliu = j.error || j.detail || ''; } catch (_e) { /* fara detaliu */ }
          console.error('Eroare x-oauth:', res.status, detaliu);
          // Un cont de retea tine de un singur client. Cel mai des: browserul e logat pe retea cu
          // contul altui client (vazut pe viu pe 9 octombrie 2026, la Jackpot, cu contul lui Dan).
          if (detaliu === 'cont_legat_de_alt_client') {
            setStatus(t('callback', 'contLegat'));
            setTimeout(() => { window.location.href = `/?error=cont_legat`; }, 9000);
            return;
          }
          // Creditul aplicatiei s-a terminat: nici citirea profilului nu mai trece.
          if (detaliu === 'x_fara_credit') {
            setStatus(t('x', 'faraCredit'));
            setTimeout(() => { window.location.href = `/?error=x_fara_credit`; }, 9000);
            return;
          }
          setStatus(t('x', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
          return;
        }
        setStatus(t('x', 'conectatRedirect'));
        window.location.href = `/?x=connected&client=${state}`;
      } catch (err) {
        console.error('Eroare OAuth:', err);
        setStatus(t('x', 'eroareConectare'));
        setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
      }
    }

    proceseazaCallback();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Sans, sans-serif', color: '#1A6B3C' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
        <div>{status}</div>
      </div>
    </div>
  );
}
